import {
  buildWidget
} from './table-view';

require('./fact-widget.component.scss');

function str2ab(str) {
  const buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
  const bufView = new Uint16Array(buf);
  for (let i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}

export function FactsWidgetComponent($compile) {
  return {
    restrict: 'E',
    scope: {
      model: '<',
      filter: '<',
      fact: '<',
      openImage: '<',
      listType: '<',
    },
    controller: function(
      $scope,
      $element,
      LocalStorageService,
    ) {
      $scope.isCollapsed = $scope.listType === 'full';
      $scope.collapse = function() {
        $scope.isCollapsed = !$scope.isCollapsed;
        if ($scope.isCollapsed) {
          $element.addClass('collapsed');
        } else {
          $element.removeClass('collapsed');
        }
      };
      $scope.collapse();

      $scope.copyToClippboard = (e) => {
        e.stopPropagation();
        const text = e.target.closest('.widget-value').innerText;
        LocalStorageService.copyTextToClipboard(text);
      };

    },
    link: function(scope, element, attrs) {
    
      if (!scope.openImage) {
        scope.openImage = () => {};
      }
      const widget = buildWidget(scope.fact);
      element.append(widget);
      $compile(element.contents())(scope);
    },
  };
}



// WEBPACK FOOTER //
// ./src/facts/fact-widget.component.js